import React from 'react';
import { Modal } from '../../components/ui';
import { isWeddingFunction, MAX_NAME } from '../../utils/helpers';

// Desktop add / edit dialog for a person the guest brings: surname · name ·
// mobile on one line (each box as wide as what goes in it), the functions as a
// two-column list of bordered rows. Enter saves (and starts the next one when
// adding). Logic: useGuestHome.
export default function GuestFormDesktop({ vm }) {
  const { editing, form, formErr, saving, addedCount, pickerFunctions, closeForm, setField, toggleFunction, save } = vm;
  const submit = (e) => { e.preventDefault(); save({ addNext: !editing }); };

  return (
    <Modal className="pp-guest-modal" title={editing ? 'Edit guest' : 'Add a guest'} onClose={closeForm}
      footer={(
        <>
          {!editing && addedCount > 0 && <span className="chip ok" style={{ marginRight: 'auto' }}>{addedCount} added</span>}
          <button type="button" className="btn light" onClick={closeForm} disabled={saving}>{editing ? 'Cancel' : 'Done'}</button>
          {!editing && <button type="button" className="btn light" onClick={() => save()} disabled={saving}>Save &amp; close</button>}
          <button type="submit" form="guest-form" className="btn primary" disabled={saving}>
            {saving ? 'Saving…' : editing ? 'Save' : 'Save & add next'}
          </button>
        </>
      )}>
      <form id="guest-form" onSubmit={submit}>
        <div className="pp-row pp-guest-row">
          <label className="field">Surname
            <input value={form.Surname} maxLength={MAX_NAME} onChange={e => setField('Surname', e.target.value)} />
          </label>
          <label className="field">Name *
            <input value={form.GuestName} maxLength={MAX_NAME} autoFocus onChange={e => setField('GuestName', e.target.value)} />
          </label>
          <label className="field">Mobile (optional)
            <input value={form.MobileNumber} inputMode="numeric" placeholder="10 digits" onChange={e => setField('MobileNumber', e.target.value)} />
          </label>
        </div>
        <div className="pp-head-line"><span className="step-label">Invite to *</span></div>
        <div className="pp-check-list">
          {pickerFunctions.map(f => {
            const on = form.FunctionIds.includes(String(f.FunctionId));
            return (
              <label key={f.FunctionId} className={'pp-check' + (on ? ' on' : '')}>
                <input type="checkbox" checked={on} onChange={() => toggleFunction(f.FunctionId)} />
                <span className="pp-check-name" title={f.FunctionName}>{isWeddingFunction(f) ? '💍 ' : ''}{f.FunctionName}</span>
              </label>
            );
          })}
        </div>
        {formErr && <div className="guest-form-err">⚠ {formErr}</div>}
      </form>
    </Modal>
  );
}
